import { comnUtils } from "@/comn/utils";

export const ptlEnvs = {
    base: `${process.env.REACT_APP_BASE_PTL_COMN}`,
};

/*
 * 프로젝트별 공통기능(함수) 사용시 작성
 */
export const ptlUtils = {
    setHsCodeMask: () => {
        return [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/];
    },

    hasAuth: (authNm: any, auth: any) => {
        let authList = auth.get("authList");
        // console.log("authList", authList);
        if (comnUtils.isEmpty(authList)) return false;

        for (let i = 0; i < authList.length; i++) {
            const item = authList[i];

            if (item === authNm) {
                return true;
            }
        }
        return false;
    },
};
